import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBaseDotsHorizontal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12Z",
			fill: "#03142E",
			fillOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12Z",
			fill: "#03142E",
			fillOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12Z",
			fill: "#03142E",
			fillOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.75 12C17.75 11.3097 18.3096 10.75 19 10.75C19.6904 10.75 20.25 11.3097 20.25 12C20.25 12.6904 19.6904 13.25 19 13.25C18.3096 13.25 17.75 12.6904 17.75 12ZM10.75 12C10.75 11.3097 11.3096 10.75 12 10.75C12.6904 10.75 13.25 11.3097 13.25 12C13.25 12.6904 12.6904 13.25 12 13.25C11.3096 13.25 10.75 12.6904 10.75 12ZM3.75 12C3.75 11.3097 4.30964 10.75 5 10.75C5.69036 10.75 6.25 11.3097 6.25 12C6.25 12.6904 5.69036 13.25 5 13.25C4.30964 13.25 3.75 12.6904 3.75 12Z",
			stroke: "#03142E",
			strokeOpacity: .2,
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconBaseDotsHorizontal;
